var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide_in"}},[(_vm.showen)?_c('div',{staticClass:"custom_offcanvas"},[_vm._t("content")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }